import React from 'react'
import {ComponentWithModal} from 'discover'
import sortedList from 'shared/sorted_category_list'

export class CategorySelection extends ComponentWithModal {
  categoryChanged = (newCategoryId) => {
    this.props.categoryChanged(newCategoryId)
    window.scrollTo(0, 0)
    this.hideModal()
  }

  label() {
    if (!this.props.categoryId) return CategorySelection.neutralLabel

    for (let category of this.props.categories) {
      if (category.id == this.props.categoryId) return category.name
    }
  }

  options() {
    const neutralOption = { name: CategorySelection.neutralLabel }
    return [neutralOption].concat(sortedList(this.props.categories))
  }

  static get neutralLabel() {
    return I18n.t('discover.categories.index.all_categories')
  }

  modal() {
    if (!this.state.isModalActive) return null

    const categoryOptions = this.options().map(category =>
      <li className="geosuggest__item"
          onClick={ this.categoryChanged.bind(this, category.id) }
          key={ category.id || 0 }>{ category.name }</li>
    )

    return (
      <div className='geosuggest'>
        <div className='geosuggest__suggests-wrapper'>
          <ul className='geosuggest__suggests'>{ categoryOptions }</ul>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className='category-selection'>
        <a onClick={ this.showModal }>{ this.label() }</a>
        { this.modalBackground() }
        { this.modal() }
      </div>
    )
  }
}
